
































































import { Vue, Component } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import OdataResource from '@/modules/api/OdataResource';
import ICurrentDanceStyleCategory from '@/modules/form/interfaces/ICurrentDanceStyleCategory.d.ts';
import IDanceStyle from '@/modules/form/interfaces/IDanceStyle';

@Component({
    name: 'DanceCategories',
    components: {},
})
export default class DanceCategories extends Vue {
    @Getter('apiUrl', { namespace: 'configuration' }) private apiUrl!: string;
    private readonly danceStyleCategoriesUrl = '/odata/schedules/CurrentDanceStyleCategories';
    private readonly danceStyleCategoriesFilter = '$filter=IsActive%20eq%20true&$expand=DanceStyles';
    private errorMessage = '';
    private loading = false;
    private errored = false;
    private danceStyleCategoriesResource: OdataResource<ICurrentDanceStyleCategory> = new OdataResource<
        ICurrentDanceStyleCategory
    >(this.apiUrl + this.danceStyleCategoriesUrl, this.onResourceLoading, this.onResourceLoadingFinished, this.onError);
    private danceStyleCategories: ICurrentDanceStyleCategory[] = [];
    private classItemIndex = 0;

    private async mounted() {
        this.danceStyleCategoriesResource.baseUrl = this.apiUrl + this.danceStyleCategoriesUrl;
        const danceStyleCategories = (await this.danceStyleCategoriesResource.getResources(
            this.danceStyleCategoriesFilter,
        )) as ICurrentDanceStyleCategory[];
        this.danceStyleCategories = danceStyleCategories;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private onError(data: any) {
        console.error(data);
        this.errored = true;
        if (data.error !== undefined) {
            this.errorMessage = data.error.message;
        }
    }

    private onResourceLoading() {
        this.loading = true;
    }

    private onResourceLoadingFinished() {
        this.loading = false;
    }

    private getNormalizedName(name: string) {
        return name.replace(/ /g, '-').toLowerCase();
    }

    private getUrl(danceStyleCategory: string, danceStyle: IDanceStyle) {
        if (danceStyle.Link !== undefined && danceStyle.Link !== null && danceStyle.Link !== '') {
            return danceStyle.Link;
        }

        return (
            'https://www.esens.com.pl/index.php/' +
            this.getNormalizedName(danceStyleCategory) +
            '/' +
            this.getNormalizedName(danceStyle.Name)
        );
    }

    private getDanceStyleCategoryBackground(danceStyleCategory: string) {
        return "background-image: url('/images/kafelki/" + this.getNormalizedName(danceStyleCategory) + ".gif');";
    }
}
